import Commons from '../../../../Services/Common/Common';

/**
 * SAM_BASIC_02_WorkType (작업종류별 항목 관리) 스키마
 * 서버 응답: PascalCase (WORK_TYPE, RISK_NM_LIST, WORK_EQUIP_NM_LIST, PREPARATION_NM_LIST, PREPARATION_CODE_LIST 등)
 * 프론트엔드 데이터: camelCase (workTypeCd, workTypeNm, hazardousItems, safetyEquipment, preparations)
 */
export const SAM_BASIC_02_WorkType_Schema = {
  fields: {
    workTypeCd: { initial: '', label: '작업종류코드' },
    workTypeNm: { initial: '', label: '작업종류명' },
    hazardousItems: { initial: [], label: '위험사항' },
    safetyEquipment: { initial: [], label: '안전보호구' },
    preparations: { initial: [], label: '준비사항' },
  },

  mapper: {
    // 작업종류별 항목 조회
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },

    // 작업종류 코드 조회 (GetCodeInfo - 모든 코드 조회 후 프론트엔드에서 필터링)
    search2: {
      // GetCodeInfo는 파라미터가 없음
    },

    // 작업종류별 항목 저장
    save1: {
      WorkItemId: (row) => Commons.EncryptAES(row.workItemId || '') || '',
      CustCd: (row) => Commons.EncryptAES(row.custCd || '') || '',
      WorkType: (row) => Commons.EncryptAES(row.workType || row.workTypeCd || '') || '',
      RiskCodeList: (row) => Commons.EncryptAES(row.riskCodeList || '') || '',
      RiskNmList: (row) => Commons.EncryptAES(row.riskNmList || '') || '',
      WorkEquipCodeList: (row) => Commons.EncryptAES(row.workEquipCodeList || '') || '',
      WorkEquipNmList: (row) => Commons.EncryptAES(row.workEquipNmList || '') || '',
      PreparationCodeList: (row) => Commons.EncryptAES(row.preparationCodeList || '') || '',
      PreparationNmList: (row) => Commons.EncryptAES(row.preparationNmList || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    // 작업종류 삭제
    delete1: {
      CustCd: (row) => Commons.EncryptAES(row.custCd || '') || '',
      WorkType: (row) => Commons.EncryptAES(row.workType || row.workTypeCd || '') || '',
    },

    // 사업장별 커스텀 작업종류 조회
    searchCust: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },

    // 사업장별 커스텀 작업종류 등록
    saveCust: {
      CustCd: (_, context) =>
        Commons.EncryptAES(
          context.custCd || context.search?.custCd || ''
        ) || '',
      WorkTypeNm: (_, context) =>
        Commons.EncryptAES(context.workTypeNm || '') || '',
      IsPrimary: (_, context) =>
        Commons.EncryptAES(context.isPrimary === 'Y' ? 'Y' : 'N') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    // 사업장별 커스텀 작업종류 삭제
    deleteCust: {
      CustCd: (_, context) =>
        Commons.EncryptAES(
          context.custCd || context.search?.custCd || ''
        ) || '',
      WorkType: (_, context) =>
        Commons.EncryptAES(context.workType || context.workTypeCd || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
